<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('segments') }} -> {{ $t('list-segments') }}
    </h1>
    <div class="main__body">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">№</th>
          <th scope="col">{{ $t('name-segment') }}</th>
          <th scope="col">{{ $t('count-player') }}</th>
          <th scope="col">
            <img src="@/assets/social/telegram.svg">
          </th>
          <th scope="col">
            <img src="@/assets/social/viber.svg">
          </th>
          <th scope="col">
            <img src="@/assets/social/email.svg">
          </th>
          <th scope="col">
            <img src="@/assets/social/sms.svg">
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in segments" v-bind:key="item.id">
          <th scope="row">
            {{ index + 1}}
          </th>
          <td class="pointer" v-on:click.self="viewSegment(item.id)" v-if="item.clientCount > 0">{{ item.name }}</td>
          <td v-else>{{ item.name }}</td>
          <td>{{ item.clientCount }}</td>
          <td>{{ item.telegramCount }}</td>
          <td>{{ item.viberCount }}</td>
          <td>{{ item.emailCount }}</td>
          <td>
            {{ item.smsCount }}
            <label class="table__td-trash pointer" @click="deleteAccept(item.id, item.name)">
              <img src="@/assets/icon/trash.svg">
            </label>
          </td>
        </tr>
        </tbody>
      </table>
      <!--
        <div class="form-row justify-content-center" v-if="clients.length > 10">
          <a class="btn">{{ $t('show-more') }}</a>
        </div>
        !-->
    </div>
    <remove-segment-modal :segment="this.deleteSegment" v-show="isModalDeleteSegmentVisible"
    @close="closeModalDeleteSegmentVisible"></remove-segment-modal>
    <loading :active.sync="isLoading"
             :can-cancel="true"
             :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import axios from 'axios'
import clientInSegmentModal from "../components/modal/clientInSegmentModal";
import loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import RemoveSegmentModal from "../components/modal/segment/remove-segment-modal";
export default {
  name: 'list-segment',
  data: function(){
    return{
      segments: [],
      deleteSegment: {
        id: 0,
        name: ''
      },
      selectedSegment: 0,
      selectedSegmentName: null,
      isLoading: false,
      fullPage: true,
      isModalDeleteSegmentVisible: false,
    }
  },
  created: function(){
    this.getSegments();
  },
  mounted() {
    this.$root.$on('updateSegments', () => {
      this.getSegments();
    });
  },
  methods: {
    viewSegment: function(id){
      this.$router.push({
        path: `/view-segment/${id}`
      });
    },
    getSegments: function(){
      this.isLoading = true;
      axios.post('getSegments').then(response => {
        var status = response.data.status;
        if(status){
          this.segments = response.data.segments;
          this.isLoading = false;
        }
      });
    },
    deleteAccept: function(id, name){
      this.deleteSegment.id = id;
      this.deleteSegment.name = name;
      this.showModalDeleteSegmentVisible();
    },
    showModalDeleteSegmentVisible() {
      this.isModalDeleteSegmentVisible = true;
    },
    closeModalDeleteSegmentVisible() {
      this.isModalDeleteSegmentVisible = false;
    },
  },
  components: {
    RemoveSegmentModal,
    loading, clientInSegmentModal
  }
}
</script>